import { NbThemeService } from '@nebular/theme';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { catchError, Observable, throwError, tap } from 'rxjs';
import { SignOutService } from 'src/app/modules/authentication/services/sign-out.service';
import { ProfileAuthorizationsService } from '../services/profile-authorizations.service';

@Injectable()
export class GeneralInterceptor implements HttpInterceptor {

  constructor(
    private signoutService: SignOutService,
    private themeService: NbThemeService,
    private profileAuthorizationsService: ProfileAuthorizationsService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isConfigUpdateRequest = request.method === 'PUT' && request.url.includes('/main-private/v1/providers/') && request.url.includes('/configs');
    if (isConfigUpdateRequest) {
      this.profileAuthorizationsService.setShouldReloadMenu(false);
    }
    return next.handle(request).pipe(
      tap((event) => {
        if (isConfigUpdateRequest && (event instanceof HttpResponse)) {
          setTimeout(() => {
            this.profileAuthorizationsService.setShouldReloadMenu(true);
          }, 100);
        }
      }),
      catchError((err: HttpErrorResponse) => {
        if (isConfigUpdateRequest) {
          setTimeout(() => {
            this.profileAuthorizationsService.setShouldReloadMenu(true);
          }, 100);
        }
        if (err?.error === 'Token expirado.') {
          setTimeout(() => {
            this.themeService.changeTheme('default');
            this.signoutService.signOut(true);
          }, 1000);
        }
        if (err?.error === 'Desconectado por acessar um IP não autorizado. Verifique sua rede.') {
          setTimeout(() => {
            this.themeService.changeTheme('default');
            this.signoutService.signOut(false, true);
          }, 1000);
        }
        return throwError(() => err)
      })
    );
  }
}
